<template>
  <IQOS required :title="$t('settings.mail.title')">
    <form class="gap-row-xs mt-16" @submit.prevent="onChangeEmail">
      <!-- <h4 class="c-white title">{{$t('settings.mail.current')}}</h4> -->
      <BaseInput
        class="w-100"
        :placeholder="$t('settings.mail.current')"
        :value="owner.email"
        disabled
        position="center"
      />
      <BaseDivider color="v1-grey-4" />
      <!-- <h4 class="c-white title">{{$t('settings.mail.new')}}</h4> -->
      <BaseInput
        class="w-100"
        :placeholder="$t('settings.mail.new')"
        type="email"
        :readonly="false"
        position="center"
        v-model="form.new_email"
        v-if="!success"
      />
      <!-- <h4 class="c-white title">{{$t('settings.mail.confirm')}}</h4> -->
      <BaseInput
        class="w-100"
        :placeholder="$t('settings.mail.confirm')"
        type="password"
        v-model="form.password"
        position="center"
        :valid="!error"
        :readonly="false"
        :disabled="busy"
        v-if="!success"
      />
      <!-- 
              EDUARD WARNING: 
              if this button is THE SAME across all panels - please use a component 
            -->
      <BaseDivider color="v1-grey-4" />
      <div class="iqos-flex-right">
        <BaseButton variant="secondary" size="md" v-if="!success">
          {{ $t("settings.mail.change") }}
        </BaseButton>
      </div>
      <div class="iqos-comment qrw-paragraph-md" v-if="success">
        {{ $t("settings.mail.sent") }}
      </div>
      <!-- <div class="error-block c-red" v-if="error">
        {{ error }}
      </div> -->
    </form>
  </IQOS>
</template>

<script>
import IQOS from "@/components/IQOS.vue";
import BlackInput from "@/components/BlackInput.vue";

import DashboardButton from "@/components/DashboardButton.vue";

import AuthAPI from "@/api/auth";

export default {
  data() {
    return {
      form: {
        new_email: null,
        password: null,
      },
      error: null,
      success: false,
      busy: false,
    };
  },
  methods: {
    onChangeEmail() {
      this.error = null;
      this.success = false;
      this.busy = true;

      AuthAPI.changeEmail(this.form.new_email, this.form.password)
        .then((ok) => {
          this.success = true;
          this.busy = false;
        })
        .catch((error) => {
          this.error = this.$t("settings.mail.errorp");
          this.busy = false;
        });
    },
  },
  components: {
    IQOS,
    BlackInput,
    DashboardButton,
  },
  computed: {
    owner() {
      return this.$store.state.owner;
    },
  },
};
</script>

<style scoped>
.success-block {
  text-align: center;
}

.error-block {
  text-align: center;
}
</style>